import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "./useAppContext";
import { useClient } from "./useClient";

export function useConfigs(requests: eXpress.core.ConfigRequest[]) {
	const client = useClient();
	const { reactQueryNoReloadOptions } = useAppContext();

	const { data: values, isLoading } = useQuery<
		eXpress.collections.Dictionary<string, string | null | undefined>,
		unknown,
		(string | undefined)[]
	>(requests, () => client.getConfigsAsync(requests), {
		...reactQueryNoReloadOptions,
		select: (data) => requests.map((request) => data.get(request.key)),
	});

	return [values || [], isLoading] as const;
}
